module.exports = __webpack_public_path__ + "static/media/logocounter.636f9d7a.png";